import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { SelectFieldOption, TranslationService } from '@sdbn/common';
import { EntranceSight } from '../../action-tablet-transport-creation-profile.model';
import { FormControl, FormGroup } from '@angular/forms';

export class ActionTabletTransportCreationProfileItemEntranceSelectionDialogData {

  entrances: Array<EntranceSight>;

  constructor(data?: any) {
    if (data != null) {
      this.entrances = data.entrances;
    }
  }

}

@Component({
  selector: 'app-action-tablet-transport-creation-profile-item-entrance-selection',
  templateUrl: './action-tablet-transport-creation-profile-item-entrance-selection.component.html',
  styleUrls: ['./action-tablet-transport-creation-profile-item-entrance-selection.component.scss'],
})
export class ActionTabletTransportCreationProfileItemEntranceSelectionComponent implements OnInit {

  entrances: Array<SelectFieldOption>;
  entrance: number = null;
  
    formGroup = new FormGroup({
      selectedEntrance: new FormControl(null, [])
    });

  constructor(
    public dialogRef: MatDialogRef<ActionTabletTransportCreationProfileItemEntranceSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ActionTabletTransportCreationProfileItemEntranceSelectionDialogData,
    public translationService: TranslationService,
  ) {

  }

  ngOnInit(): void {

    const gates = new Array<SelectFieldOption>();
    for (const entrance of this.data.entrances) {
        gates.push(new SelectFieldOption({ label: entrance.name, value: entrance.id }));
    }
    this.entrances = gates;

    this.formGroup.valueChanges.subscribe(value => {
      this.entrance = value.selectedEntrance;
    });

    this.formGroup.patchValue({ selectedEntrance: this.entrances[0].value });
  }

  cancel() {
    this.dialogRef.close(null);
  }

  confirm() {
    const result = this.entrance;
    this.dialogRef.close(result);
  }

}
